<template>
  <div class="vx-col w-full h-auto" style="position: relative;">
    <SidePanelToggle v-if="isBigScreen"
                     :sidePanelActive="sidePanelActive"
                     @toggleSidePanel="toggleSidePanel">
    </SidePanelToggle>

    <transition mode="out-in" name="panel-fade">
      <component :is="mainPanelMode"
                 :countLearningPercent="countLearningPercent"
                 :currentCourseOutlineUnit="currentCourseOutlineUnit"
                 :currentStudentUnitTest="currentStudentUnitTest"
                 :currentVdoSetTopic="currentVdoSetTopic"
                 :isBigScreen="isBigScreen"
                 :forceStopVideo="forceStopVideo"

                 :examMode="examMode"
                 :keepCounting="keepCounting"
                 :studentEnrollDetail="studentEnrollDetail"
                 @onVideoStopped="$emit('onVideoStopped')"
                 @setDoingExam="setDoingExam"
                 @setNewStudentUnitTestToCourseOutlineUnits="setNewStudentUnitTestToCourseOutlineUnits"
                 @setTriggerLoading="setTriggerLoading"
                 @startLearning="startLearning"
      />
    </transition>

  </div>

</template>

<script>
import SidePanelToggle from "./sidepanel-toggle";
import cover from "./panel-cover";

export default {
  props: [
    'studentEnrollDetail',
    'currentVdoSetTopic',
    'sidePanelActive',
    'toggleSidePanel',
    'mainPanelMode',
    'keepCounting',
    'countLearningPercent',
    'currentCourseOutlineUnit',
    'examMode',
    'currentStudentUnitTest',
    'setNewStudentUnitTestToCourseOutlineUnits',
    'startLearning',
    'setDoingExam',
    'setTriggerLoading',
    'isBigScreen',
    'forceStopVideo',
  ],
  components: {
    SidePanelToggle,
    cover,
    vdo: () => import( "./MainPanel-Vdo"),
    test: () => import("./MainPanel-StudentUnitTest")
  },
}

</script>

<style>

</style>
